'use strict';
/**
 * Variadic helper function
 *
 * @param args
 * @returns {Array}
 */

module.exports = function variadic(args) {
  if (Array.isArray(args[0])) {
    return args[0];
  }

  return args;
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/helpers/variadic.js
// module id = 247
// module chunks = 2